import React from 'react';

const FlashSection = ({ flashInfos, setFlashInfos, handleUpdateFlash, flashStatus, user }) => {
  const handleInputChange = (index, value) => {
    const newInfos = [...flashInfos];
    newInfos[index] = value;
    setFlashInfos(newInfos);
  };

  const addField = () => setFlashInfos([...flashInfos, ""]);

  return (
    <div className="card bg-dark border-0 shadow-lg rounded-5 overflow-hidden border-top border-5 border-danger mb-4">
      <div className="card-body p-3 p-md-5">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4 className="fw-black text-uppercase mb-0">
            <i className="bi bi-megaphone-fill text-danger me-2"></i>Flux d'actualités
          </h4>
          <button type="button" onClick={addField} className="btn btn-sm btn-outline-light rounded-pill px-3 fw-bold">
            + Ajouter une ligne
          </button>
        </div>
        
        <form onSubmit={handleUpdateFlash}>
          <div className="row g-3">
            {flashInfos.map((info, index) => (
              <div key={index} className="col-12">
                <div className="input-group shadow-sm">
                  <span className="input-group-text bg-black border-secondary text-danger fw-black px-3">{index + 1}</span>
                  <input 
                    type="text"
                    className="form-control form-control-lg bg-black border-secondary text-white shadow-none"
                    value={info}
                    onChange={(e) => handleInputChange(index, e.target.value)}
                    placeholder={`Saisir l'actualité n°${index + 1}...`}
                  />
                  <button 
                    type="button" 
                    className="btn btn-outline-secondary border-secondary bg-black px-3"
                    onClick={() => setFlashInfos(flashInfos.filter((_, i) => i !== index))}
                  >
                    <i className="bi bi-trash3 text-danger"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-5 d-flex flex-column flex-md-row align-items-center gap-4">
            <button type="submit" className="btn btn-danger btn-lg rounded-pill px-5 fw-black text-uppercase shadow-lg w-100 w-md-auto">
              Mettre à jour
            </button>
            <div className="d-flex flex-column text-center text-md-start">
              <span className="fw-bold text-info">{flashStatus}</span>
              <small className="text-secondary italic">Par : <b className="text-white">{user?.username}</b></small>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FlashSection;